import React from 'react';
import { useDispatch } from 'react-redux';
import { PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js';

import Notification from '../../../../components/Notification/Notification';
import stripeActionConstants from '../../../../redux/constants/stripeActionConstants';

import styles from './PaymentForm.module.scss';

const PaymentForm = () => {
  const dispatch = useDispatch();
  const stripe = useStripe();
  const elements = useElements();

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    dispatch({ type: stripeActionConstants.CREATE_PAYMENT_METHOD });
    const { error } = await stripe.confirmSetup({
      elements,
      confirmParams: {
        return_url: `${window.location.href}/status`,
      },
    });
    dispatch({ type: stripeActionConstants.CREATE_PAYMENT_METHOD_SUCCESS });

    if (error) {
      Notification.error(error.message);
    }
  };
  return (
    <div className={styles.stripePayment}>
      <form onSubmit={handleSubmit}>
        <PaymentElement />
        <button type="submit" disabled={!stripe}>
          Submit
        </button>
      </form>
    </div>
  );
};

export default PaymentForm;
